import { RoleManagementComponent } from "@/Administration/Components/Roles/RoleManagementComponent";
import { Client } from "@/Common/Api/Client";
import { PdfTag } from "@/Common/Api/RadPdf/Dto/Responses/PdfTag";
import { EmptyProps } from "@/Common/Components/BaseReactComponent";
import { FeatureFlagControl } from "@/Common/Components/FeatureFlagControl";
import { EnumMyleLoginPermission } from "@/Common/Models/EnumMyleLoginPermission";
import { AdminTabViews } from "@/Common/Models/UI/Enums";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { PermissionGate } from "@/Common/Permissions/PermissionGate";
import { IBillableServiceModel } from "../Models/UI/BillableService/IBillableServiceModel";
import { IExternalConsultationHistoryGridModel } from "../Models/UI/ExternalConsultationHistory/IExternalConsultationHistoryGridModel";
import { IGroupTabModel } from "../Models/UI/Group/IGroupTabModel";
import { ILogTabModel } from "../Models/UI/Logs/ILogTabModel";
import { IServiceComboGridModel } from "../Models/UI/ServiceCombo/IServiceComboGridModel";
import { ISiteCreateModel } from "../Models/UI/Sites/ISiteCreateModel";
import { ISitesTabModel } from "../Models/UI/Sites/ISitesTabModel";
import { ISiteViewModel } from "../Models/UI/Sites/ISiteViewModel";
import { IAdminTabModel } from "../Models/UI/Tabs/IAdminTabModel";
import { IUsersTabModel } from "../Models/UI/Users/IUsersTabModel";
import { BillableServiceTabView } from "./BillableService/BillableServiceTabView";
import { GroupAdminTab } from "./Group/GroupAdminTab";
import { LogTab } from "./Logs/LogTab";
import { QuestionnairesTab } from "./Questionnaires/QuestionnairesTab";
import { ServiceComboTabView } from "./Services/ServiceComboTabView";
import SitesTab from "./Sites/SitesTab";
import { UsersAdminTab } from "./Users/UsersAdminTab";
import { XComLogsView } from "./XComLogs/XComLogsView";

class AdminTabState {
    public model: IAdminTabModel;
    public serviceComboGridModel: IServiceComboGridModel;
    public usersTabModel: IUsersTabModel;
    public groupTabModel: IGroupTabModel;
    public billableServiceModel: IBillableServiceModel;
    public sitesTabModel: ISitesTabModel;
    public siteViewModel: ISiteViewModel;
    public siteCreateModel: ISiteCreateModel;
    public logTabModel: ILogTabModel;
    public externalConsultationHistoryGridModel: IExternalConsultationHistoryGridModel;
}

class AdminTab extends React.Component<EmptyProps, AdminTabState> {
    private adminChangeListenerMethodId: string;
    private cacheChangeListenerMethodId: string;

    public constructor(props: Readonly<AdminTabState>) {
        super(props);
        this.state = this.getDefaultState();
    }

    public render(): JSX.Element {
        return (

            <div className="sub-container">

                <div className="workspace-admin">

                    <div className="patient-subtabs myle-page-tab-header" style={{ textAlign: "left" }}>
                        <ul>
                            <PermissionGate
                                requiredPermission={EnumMyleLoginPermission.Administration_SiteTabPermission}
                                bypassRestriction={!cacheStore.ClinicSettings.EnableUserSettingsUiImprovements}
                            >
                                {this.buildProfileTab(AdminTabViews.Sites, "SitesLabel")}
                            </PermissionGate>

                            <PermissionGate
                                requiredPermission={EnumMyleLoginPermission.Administration_ServiceCombosTabPermission}
                                bypassRestriction={!cacheStore.ClinicSettings.EnableUserSettingsUiImprovements}
                            >
                                {this.buildProfileTab(AdminTabViews.ServiceCombos, "ServiceComboLabel")}
                            </PermissionGate>

                            <PermissionGate
                                requiredPermission={EnumMyleLoginPermission.Administration_UsersTabPermission}
                                bypassRestriction={!cacheStore.ClinicSettings.EnableUserSettingsUiImprovements}
                            >
                                {this.buildProfileTab(AdminTabViews.Users, "UsersLabel")}
                            </PermissionGate>

                            <FeatureFlagControl
                                flag={cacheStore.ClinicSettings.EnableRoleBasedAccessControl}
                                activeFeature={(
                                    <PermissionGate
                                        requiredPermission={EnumMyleLoginPermission.Administration_RolesTabPermission}
                                        bypassRestriction={!cacheStore.ClinicSettings.EnableRoleBasedAccessControl}
                                    >
                                        {this.buildProfileTab(AdminTabViews.Roles, "RoleBasedAccessControl_RolesLabel")}
                                    </PermissionGate>
                                )}
                                fallbackFeature={null}
                            />

                            <PermissionGate
                                requiredPermission={EnumMyleLoginPermission.Administration_BillableServicesTabPermission}
                                bypassRestriction={!cacheStore.ClinicSettings.EnableUserSettingsUiImprovements}
                            >
                                {this.buildProfileTab(AdminTabViews.BillableServices, "BillableServicesLabel")}
                            </PermissionGate>

                            <PermissionGate
                                requiredPermission={EnumMyleLoginPermission.Administration_CommunicationGroupsTabPermission}
                                bypassRestriction={!cacheStore.ClinicSettings.EnableUserSettingsUiImprovements}
                            >
                                {this.buildProfileTab(AdminTabViews.Groups, "GroupLabel")}
                            </PermissionGate>

                            <PermissionGate
                                requiredPermission={EnumMyleLoginPermission.Administration_QuestionnairesTabPermission}
                                bypassRestriction={!cacheStore.ClinicSettings.EnableUserSettingsUiImprovements}
                            >
                                {cacheStore.ClinicSettings.EnableCovidQuestionnaire &&
                                    this.buildProfileTab(AdminTabViews.Questionnaires, "QuestionnairesLabel")
                                }
                            </PermissionGate>

                            <PermissionGate
                                requiredPermission={EnumMyleLoginPermission.Administration_LogsTabPermission}
                                bypassRestriction={!cacheStore.ClinicSettings.EnableUserSettingsUiImprovements}
                            >
                                {this.buildProfileTab(AdminTabViews.Log, "LogsLabel")}
                            </PermissionGate>

                            {cacheStore.ClinicSettings.EnableExternalCommunicationV2 && (
                                <PermissionGate requiredPermission={EnumMyleLoginPermission.Administration_ExternalConsultationTabPermission} bypassRestriction={!cacheStore.ClinicSettings.EnableUserSettingsUiImprovements}>
                                    {this.buildProfileTab(AdminTabViews.ExternalConsultationHistory, "ExternalConsultationHistoryLabel")}
                                </PermissionGate>
                            )}
                        </ul>
                    </div>

                    <div className="profile-subtabs-container">
                        {this.showTabComponents(this.state.model.get("CurrentView"))}
                    </div>
                </div>
            </div>
        );
    }

    public componentDidMount(): void {
        this.adminChangeListenerMethodId = administrationStore.AddChangeListener(this.changeListener, this, "admin-tab-listener");
        this.cacheChangeListenerMethodId = cacheStore.AddChangeListener(this.changeListener, this, "cache-tab-listener");

        if (cacheStore.radPdfTagsCache == null || cacheStore.radPdfTagsCache.count() == 0) {
            Client.Post(
                ServerOperations.Server.LoadPDFTags,
                {},
                response => {
                    if (response.Tags && response.Tags.length > 0) {
                        let tags: PdfTag[] = response.Tags;
                        cacheStore.radPdfTagsCache = tags.map(tag => new KeyValuePair(tag.Id, tag.Tag)).toImmutable();
                    }
                }
            );
        }
    }

    public componentWillUnmount(): void {
        administrationStore.RemoveChangeListener(this.adminChangeListenerMethodId);
        cacheStore.RemoveChangeListener(this.cacheChangeListenerMethodId);
    }

    private changeListener(): void {
        this.setState(this.getDefaultState());
    }

    private getDefaultState(): AdminTabState {
        let s = new AdminTabState();
        s.model = administrationStore.adminTabModel;
        s.serviceComboGridModel = administrationStore.serviceComboGridModel;
        s.usersTabModel = administrationStore.usersTabModel;
        s.groupTabModel = administrationStore.groupTabModel;
        s.billableServiceModel = administrationStore.billableServiceTabModel;
        s.sitesTabModel = administrationStore.sitesTabModel;
        s.siteViewModel = administrationStore.siteViewModel;
        s.siteCreateModel = administrationStore.siteCreateModel;
        s.logTabModel = administrationStore.logTabModel;
        s.externalConsultationHistoryGridModel = administrationStore.XComLogGridModel;
        return s;
    }

    private onTabClick(tab: AdminTabViews): void {
        sessionStore.dispatch(LocalOperations.AdministrationTab.SubTabSwitch, { value: tab });
    }

    private buildProfileTab(tab: AdminTabViews, labelKey: string): JSX.Element {
        let css = this.state.model.get("CurrentView") === tab ? "active" : null;
        return (
            <li className={css} data-cy={`adminTab-${AdminTabViews[tab].toLowerCase()}`}>
                <a onClick={this.onTabClick.bind(this, tab)}>
                    {cacheStore.GetString(labelKey)}
                </a>
            </li>
        );
    }

    private showTabComponents(current: AdminTabViews): JSX.Element {
        switch (current) {
            case AdminTabViews.Sites:
                return (
                    <SitesTab
                        model={this.state.sitesTabModel}
                        selectedSite={this.state.siteViewModel}
                        createSiteModel={this.state.siteCreateModel}
                    />
                );

            case AdminTabViews.ServiceCombos:
                return (
                    <ServiceComboTabView
                        model={this.state.serviceComboGridModel}
                        serviceDefinitions={cacheStore.ServiceDefinitionCache}
                        serviceComboDefinitions={cacheStore.ServiceDefinitionComboCache}
                    />
                );

            case AdminTabViews.BillableServices:
                return (
                    <BillableServiceTabView
                        model={this.state.billableServiceModel}
                        costCenters={cacheStore.CostCenterCache}
                    />
                );

            case AdminTabViews.Groups:
                return (
                    <GroupAdminTab
                        groupTabModel={this.state.groupTabModel}
                        serviceDefinitionCache={cacheStore.ServiceDefinitionCache}
                        serviceComboDefinitionCache={cacheStore.ServiceDefinitionComboCache}
                    />
                );

            case AdminTabViews.Users:
                return (
                    <UsersAdminTab
                        usersTabModel={this.state.usersTabModel}
                        serviceDefinitionCache={cacheStore.ServiceDefinitionCache}
                        serviceComboDefinitionCache={cacheStore.ServiceDefinitionComboCache}
                    />
                );

            case AdminTabViews.Roles:
                return (
                    <RoleManagementComponent />
                );

            case AdminTabViews.Log:
                return (
                    <LogTab
                        model={this.state.logTabModel}
                    />
                );

            case AdminTabViews.Questionnaires:
                return (<QuestionnairesTab availableQuestionnaires={cacheStore.AvailableQuestionnaires} />);

            case AdminTabViews.ExternalConsultationHistory:
                return (
                    <XComLogsView
                        model={this.state.externalConsultationHistoryGridModel}
                    />
                );
            default:
                return <div />;
        }
    }
}

export { AdminTab };
